<template>
  <div style='margin: 20px 0 0 50px;'>
    <div>
      <router-link to="/admin/posts/regulation_checks">
        ←一覧に戻る
      </router-link>
    </div>
    <v-form ref="regulationForm">
    <div style='margin: 20px auto 0; display: flex;'>
        <v-text-field
          v-model="editingRegulationBundler.name"
          label="レギュレーションチェック名"
          :rules="[(value) => !!value || '必ず入力してください']"
          style='width: 260px; margin-right: 20px;'
          outlined
        />
      <v-select
        v-model="selectedVariety"
        :items="variety"
        item-text="itemName"
        item-value="itemValue"
        label="追加するアイテムを選択"
        solo
        style='max-width: 240px; margin-right: 20px;'
      />
      <v-btn
        color="blue darken-1"
        class="mt-2 white--text"
        @click="addRegulationItem"
      >
        追加
      </v-btn>
      <v-btn
        v-if="editingRegulationBundler.id == null"
        color="green darken-1"
        class="mt-2 ml-5 white--text"
        @click="createRegulationBundler"
      >
        このレギュレーションチェックを保存する
      </v-btn>
      <v-btn
        v-else
        color="green darken-1"
        class="mt-2 ml-5 mb-5 white--text"
        @click="updateRegulationBundler"
      >
        このレギュレーションチェックを更新する
      </v-btn>
    </div>
    <div style='display: flex; align-items: flex-end;'>
      <v-card
        style='width: 700px; height: 500px; overflow-y: scroll;'
        id='regulationItemsScroll'
        outlined
        tile
      >
        <draggable v-model="regulationItems" handle=".handle">
          <v-card
            v-for="(regulationItem, index) in regulationItems"
            :key="regulationItem.id"
            class="ma-4 pt-2"
            outlined
            style='display: flex;'
          >
            <v-icon x-large class="handle" style='width: 10%;'>mdi-format-line-spacing</v-icon>
            <div style='width: 400px; width: 90%;'>
              <div class='px-4' style='display: flex; justify-content: space-between;'>
                <span class='mt-2' style='font-weight: 600;'>{{ regulationItemI18ns.variety[regulationItem.variety] }}</span>
                <v-btn text icon @click="deleteRegulationItem(index)">
                  <v-icon> mdi-close </v-icon>
                </v-btn>
              </div>
              <v-text-field
                v-model="regulationItem.warningText"
                label="注意文"
                :rules="[(value) => !!value || '必ず入力してください']"
                class='px-4'
                style='max-width: 600px;'
              />

              <entire-range-limit-item
                v-if="regulationItem.variety == 'entire_range_limit'"
                :regulation-item="regulationItem"
              />
              <eyecatch-existence-item
                v-else-if="regulationItem.variety == 'eyecatch_existence'"
                :regulation-item="regulationItem"
              />
              <introduction-range-limit
                v-else-if="regulationItem.variety == 'introduction_range_limit'"
                :regulation-item="regulationItem"
              />
              <introduction-keyword-frequency
                v-else-if="
                  regulationItem.variety == 'introduction_keyword_frequency'
                "
                :regulation-item="regulationItem"
              />
              <heading2-frequency
                v-else-if="regulationItem.variety == 'heading2_frequency'"
                :regulation-item="regulationItem"
              />
              <item-after-heading3
                v-else-if="regulationItem.variety == 'item_after_heading3'"
                :regulation-item="regulationItem"
              />
              <heading3-after-heading2
                v-else-if="regulationItem.variety == 'heading3_after_heading2'"
                :regulation-item="regulationItem"
              />
              <text-between-heading3
                v-else-if="regulationItem.variety == 'text_between_heading3'"
                :regulation-item="regulationItem"
              />
              <text-item-range-limit
                v-else-if="regulationItem.variety == 'text_item_range_limit'"
                :regulation-item="regulationItem"
              />
              <rank-keyword-frequency
                v-else-if="regulationItem.variety == 'rank_keyword_frequency'"
                :regulation-item="regulationItem"
              />
            </div>
          </v-card>
        </draggable>
      </v-card>
    </div>
    </v-form>
  </div>
</template>

<script>
import axios from 'axios'
import draggable from 'vuedraggable'
import { deserialize } from 'deserialize-json-api'
import { mapState } from 'vuex'
import EntireRangeLimitItem from './EntireRangeLimitItem'
import EyecatchExistenceItem from './EyecatchExistenceItem'
import IntroductionRangeLimit from './IntroductionRangeLimit'
import IntroductionKeywordFrequency from './IntroductionKeywordFrequency'
import Heading2Frequency from './Heading2Frequency'
import ItemAfterHeading3 from './ItemAfterHeading3'
import Heading3AfterHeading2 from './Heading3AfterHeading2'
import TextBetweenHeading3 from './TextBetweenHeading3'
import TextItemRangeLimit from './TextItemRangeLimit'
import RankKeywordFrequency from './RankKeywordFrequency'
import snakecaseKeys from 'snakecase-keys'

export default {
  name: 'RegulationItem',
  components: {
    EntireRangeLimitItem,
    EyecatchExistenceItem,
    IntroductionRangeLimit,
    IntroductionKeywordFrequency,
    Heading2Frequency,
    ItemAfterHeading3,
    Heading3AfterHeading2,
    TextBetweenHeading3,
    TextItemRangeLimit,
    RankKeywordFrequency,
    draggable
  },
  props: {
    regulationItemsProps: {
      type: Array,
      required: true
    },
    destroyRegulationItemsProps: {
      type: Array,
      required: true
    },
    editingRegulationBundler: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      regulationItems: this.regulationItemsProps,
      destroyRegulationItems: this.destroyRegulationItemsProps,
      selectedVariety: ''
    }
  },
  computed: {
    ...mapState({
      regulationItemI18ns: (state) => snakecaseKeys(state.I18n.enums.regulationItem)
    }),
    variety: function () {
      let tmpObject = snakecaseKeys(this.$store.state.I18n.enums.regulationItem.variety)

      let tmpArr = []
      Object.keys(tmpObject).forEach(function (key) {
        tmpArr.push({ itemName: tmpObject[key], itemValue: key })
      })
      return tmpArr
    }
  },
  watch: {
    regulationItemsProps: {
      immediate: true,
      handler (value) {
        this.regulationItems = value
      }
    },
    destroyRegulationItemsProps: {
      immediate: true,
      handler (value) {
        this.destroyRegulationItems = value
      }
    }
  },
  methods: {
    deleteRegulationItem (index) {
      this.regulationItems[index]._destroy = true
      this.destroyRegulationItems.push(this.regulationItems[index])
      this.regulationItems.splice(index, 1)
    },
    addRegulationItem () {
      const regulationItem = {
        id: null,
        type: 'regulation_item',
        regulationBundlerId: this.editingRegulationBundler.id,
        order: this.regulationItems.length,
        rules: {},
        variety: this.selectedVariety,
        warningText: '',
        _destroy: false
      }
      this.regulationItems.push(regulationItem)
      const el = document.getElementById('regulationItemsScroll')
      setTimeout(() => {
        el.scrollTo({
          top: el.scrollHeight + 1000,
          behavior: 'smooth'
        })
      }
        , 1
      )
      this.selectedVariety = ''
    },
    updateRegulationBundler () {
      if (!this.$refs.regulationForm.validate()) {
        this.$store.dispatch('SystemMessageStore/createNotStatusMessage', {color: 'error', text: '入力値にエラーがあります。スクロールしてエラー箇所を修正して下さい。'})
        return false
      }
      // orderをindexで張替え
      this.regulationItems.forEach((item, index) => {
        this.regulationItems[index].order = index
      })

      const query = {
        regulation_bundler: {
          id: this.editingRegulationBundler.id,
          name: this.editingRegulationBundler.name,
          regulationItems_attributes: this.regulationItems.concat(
            this.destroyRegulationItems
          )
        }
      }
      axios
        .patch(
          `/api/regulation_bundlers/${this.editingRegulationBundler.id}`,
          this.queryToSnakecase(query)
        )
        .then(
          ({ data }) => {
            const payload = {
              status: 200,
              message: '変更を保存しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.regulationBundler = deserialize(data).data
            this.destroyRegulationItems = []

            // 入れ子レスポンス並び替え
            let tmpArr = []
            for (
              let i = 0;
              i < this.regulationBundler.regulationItems.length;
              i++
            ) {
              this.regulationBundler.regulationItems.forEach((item) => {
                if (item.order == i) {
                  tmpArr.push(item)
                }
              })
            }
            this.regulationItems = tmpArr
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    createRegulationBundler () {
      if (!this.$refs.regulationForm.validate()) {
        this.$store.dispatch('SystemMessageStore/createNotStatusMessage', {color: 'error', text: '入力値にエラーがあります。スクロールしてエラー箇所を修正して下さい。'})
        return false
      }
      const query = {
        regulation_bundler: {
          name: this.editingRegulationBundler.name,
          regulationItems_attributes: this.regulationItems.concat(
            this.destroyRegulationItems
          )
        }
      }
      axios.post(`/api/regulation_bundlers`, this.queryToSnakecase(query)).then(
        ({ data }) => {
          const payload = {
            status: 200,
            message: '変更を保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          const regulationBundler = deserialize(data).data
          this.$emit('push-regulation-bundler', regulationBundler)
          this.$emit('close-dialog-with-bundlers')
          this.$router.push({
            name: 'adminRegulationChecks'
          })
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    queryToSnakecase (query) {
    // _destroyを除外
      return snakecaseKeys(query, {exclude: ['_destroy']})
    }
  }

}
</script>
